import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz26 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel27'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel25'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Know Average Salary without Disclosing Individual Salaries</h1>
   
    <div class="text">
        <p>Three Employees want to know the average of their salaries. They are not allowed to share their individual
            salaries.</p>
        <p><br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </p>
        <div class="containers">
        <p><strong>Answer:</strong><br/>
            1) X adds a Random Number and his salary and tells the sum to Y.</p>
        <p>2) Y also adds a Random Number and his salary to the sum told by X and tells new sum to Z.</p>
        <p>3) Z also adds a Random Number and his salary to the sum told by Y and tells new sum to X.</p><br/>
        <p>4) X subtracts its random number from the sum told by Z and tells the new number to Y.</p>
        <p>5) Y subtracts its random number from the sum told by X and tells the new number to Z.</p>
        <p>6) Z subtracts its random number from the sum told by Y and announces the new number.</p>
        <p>The new number is now the sum of three salaries and average can be calculated by dividing the sum by 3.</p>
        <p>Finally, nobody knows the salary of others, but all know average.</p>
        <p>This can be extended to more than 3 employees also.</p>
      </div>
    </div>
</article>
        </div>
    )
}

export default Puz26
